<template>
  <div class="benepoint">
    <div class="box">
      <div class="box-content">
        <div class="title">
          <strong>ベネポ利用申請</strong>
        </div>
        <div class="totalPrice">
          <strong class="price-text">支払予定額</strong>
          <strong class="price">{{ totalCostNoBenePoint | formatCurrency }}</strong>
        </div>
        <a-divider />
        <div class="menu-content2">
          <div class="content">
            <div class="benepoOwned">
              <div class="benepo-item">
                <p>保有ベネポ</p>
                <span>{{ formatNumber(totalBenepoints) }}</span>
              </div>
              <a-radio-group v-model="checkedValue" @change="onChangeOption">
                <a-radio :value="0" :disabled="notUseAll">
                  すべてのポイントを利用する
                </a-radio>
                <a-radio :value="1" :disabled="notUseAPart">
                  一部のポイントを利用する
                </a-radio>
                <a-radio :value="2" :disabled="notUse"> 利用しない </a-radio>
              </a-radio-group>
              <a-divider />
              <div v-if="checkedValue !== 2">
                <div class="input">
                  <div class="input-item items-center">
                    <a-input
                      :disabled="checkedValue === 0"
                      @keypress="validateNumber($event)"
                      class="text-input"
                      v-model="useBenepoints"
                    />
                    <span class="bene-input-prefix">ベネポ</span>
                  </div>
                  <strong class="font-bold mt-2 font-18"
                    >{{ formatNumber(numBenepo()) }}円分</strong
                  >
                </div>
                <span class="alert-message" v-if="checkErrorAlert()">{{
                  checkErrorAlert()
                }}</span>
              </div>
              <div>1ポイント単位のご利用となります</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="coupon-popup-footer sm:block">
      <Button text="申請内容を確定する" class="btn-1" type="dark" @click="saveData" />
      <Button text="キャンセル" outline @click="$emit('close')" />
      <Button text="申請内容を確定する" class="btn-2" type="dark" @click="saveData" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { Item, SectionContentTitle } from '@/components/compound'
import { SAVE_DATA_BS_APP_02_008 } from '@/store/modules/bs_app/actions'
import func_utils from '@/mixins/func_utils'
export default {
  mixins: [func_utils],
  components: {
    Item,
    SectionContentTitle
  },
  props: ['visible', 'useCafe'],
  data() {
    return {
      customerPlan: null,
      checkinTime: '',
      checkedValue: 0,
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申込確認'
        },
        {
          id: 3,
          label: '申込完了'
        }
      ],
      totalBenepoints: 0,
      useBenepoints: 0,
      dataItemOrder: {},
      totalAmount: 0,
      benepointAmount: 0,
      priceOfAPoint: 1,
      notUse: false,
      notUseAll: false,
      notUseAPart: false,
      totalAdultPeople: 0,
      totalChildren: 0
    }
  },
  mounted() {
    this.initScreen()
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.bsApp02008) {
          this.checkedValue = this.bsApp02008.checkedValue
          this.useBenepoints = this.bsApp02008.point_benepo
          this.itemContent = this.bsApp02008.itemContent
        } else {
          this.initScreen()
        }
      }
    },
    couponAmount(val) {
      this.useBenepoints = (this.totalAmount - val) / this.priceOfAPoint
      if (this.totalBenepoints < this.totalAmount) {
        this.useBenepoints = this.totalBenepoints
      }
    },
    checkedValue() {
      if (this.checkedValue === 0) {
        if (this.totalAmount < this.totalBenepoints) {
          this.useBenepoints = (this.totalAmount - this.couponAmount - this.useCafe) / this.priceOfAPoint
        } else {
          this.useBenepoints = this.totalBenepoints
        }
      }
      if (this.checkedValue === 2) {
        this.useBenepoints = 0
      }
      if (this.checkedValue === 1) {
        if (this.totalAmount < this.totalBenepoints) {
          this.useBenepoints = (this.totalAmount - this.couponAmount - this.useCafe) / this.priceOfAPoint
        } else {
          // this.useBenepoints = this.totalBenepoints
        }
      }
    }
  },
  computed: {
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(this.$store.getters.customerPlan)
    },
    couponAmount() {
      return _.get(
        this.$store.getters.customerPlan,
        'couponPlanData.totalDiscountAmount',
        0
      )
    },
    totalCost() {
      return this.totalAmount -
        this.couponAmount - 
        this.useCafe - 
        (this.checkedValue === 2 ? 0 : this.benepointAmount) >
        0
        ? this.totalAmount -
            this.couponAmount - 
            this.useCafe - 
            (this.checkedValue === 2 ? 0 : this.benepointAmount)
        : 0
    },
    totalCostNoBenePoint() {
      return this.totalAmount - this.couponAmount - this.useCafe;
    },
    bsApp02004() {
      return _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_02_004', null))
    },
    bsApp02008() {
      return _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_02_008', null))
    }
  },
  methods: {
    initScreen() {
      this.getTotalPoint()
      if (this.bsApp02008) {
        this.checkedValue = this.bsApp02008.checkedValue
        this.useBenepoints = this.bsApp02008.point_benepo
        this.itemContent = this.bsApp02008.itemContent
      } else {
        this.checkedValue = 0
      }
      this.customerPlan = this.customerPlanState
      this.getPlanBasicInfo()
    },
    onChangeOption() {
      //
    },
    mountData() {
      const bs_app_02_001 = _.cloneDeep(
        _.get(this.$store.state, 'bs_app.bs_app.bs_app_02_001', null)
      )
      if (bs_app_02_001) {
        this.checkinTime = bs_app_02_001.checkinTime // sửa lại biến
        this.totalAmount = bs_app_02_001.totalFee
        this.totalAdultPeople = bs_app_02_001.totalAdultPeople
        this.totalChildren = bs_app_02_001.totalChildren
      }
      if (this.totalAmount < this.numBenepo()) {
        this.checkedValue = 0
        this.notUse = false
        this.notUseAPart = false
        this.useBenepoints = this.totalAmount / this.priceOfAPoint
      }
      if (this.totalBenepoints === 0) {
        this.checkedValue = 2
        this.notUseAll = true
        this.notUseAPart = true
      }
      this.customerPlan = this.customerPlanState
      if (this.couponAmount || this.useCafe) {
        if (this.couponAmount >= this.totalAmount) {
          this.checkedValue = 2
          this.notUseAll = true
          this.notUseAPart = true
        } else if (this.totalAmount < this.couponAmount + this.useCafe + this.numBenepo()) {
          this.checkedValue = 0
          this.notUseAll = false
          this.notUse = false
          this.useBenepoints = (this.totalAmount - this.couponAmount - this.useCafe) / this.priceOfAPoint
        } else {
          this.checkedValue = 0
          this.notUseAPart = false
          this.notUse = false
        }
      }
    },
    getPlanBasicInfo() {
      const planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      const roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
      if (planBasicInfo && roomBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(this.getPlanInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: planBasicInfo.planImages[0].imageUrl,
          title1: _.get(this.getPlanInfo, 'menuInformation.menuNm', ''),
          title2: _.get(planBasicInfo, 'planNm', '')
        }
      }
    },
    numBenepo() {
      if (this.checkedValue === 2) {
        this.benepointAmount = 0
        return this.benepointAmount
      }
      this.benepointAmount = this.useBenepoints * this.priceOfAPoint
      return this.benepointAmount
    },
    checkErrorAlert() {
      const amountAfterCoupon =
        this.totalAmount - this.couponAmount - this.useCafe >= 0
          ? this.totalAmount - this.couponAmount - this.useCafe
          : 0
      if (this.useBenepoints === '') {
        return 'ベネポを入力してください'
      } else if (!String(this.useBenepoints).match(/^[0-9]+$/)) {
        return '半角数字のみを入力してください'
      } else if (this.useBenepoints > this.totalBenepoints) {
        return '有効なベネポを入力してください'
      } else if (this.useBenepoints > amountAfterCoupon) {
        return '負担予定額を超えるベネポは使用できません。'
      } else {
        return false
      }
    },
    getTotalPoint() {
      this.$loading.show()
      this.$repositories('benepoint')
        .getBenePoint()
        .then(
          (result) => {
            this.$loading.hide()
            this.totalBenepoints = _.get(result, 'totalPoint', 0)
            this.useBenepoints = _.get(result, 'totalPoint', 0)
            this.mountData()
          },
          (error) => {
            this.$loading.hide()
            this.$toasted.error(error)
            this.mountData()
          }
        )
    },
    gotoScreen(code) {
      const query = this.$route.query
      const { menuNo, planId, roomId } = this.$route.query
      switch (code) {
        case 1:
          this.$router.push({ path: '/' })
          return
        case 2:
          this.$router.push({ path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}` })
          return
        case 3:
          this.$router.push({ path: '/register-rooms', query })
      }
    },
    saveData() {
      const bs_app_02_008 = {
        point_benepo: this.checkedValue === 2 ? 0 : this.benepointAmount,
        checkedValue: this.checkedValue,
        dataItemOrder: this.dataItemOrder,
        itemContent: this.itemContent,
        totalAmount: this.totalCost,
        pointRemain: this.totalBenepoints - this.benepointAmount
      }
      // show pop up, navi screen ...
      if (this.checkErrorAlert()) {
        return
      }
      this.$store.dispatch(SAVE_DATA_BS_APP_02_008, bs_app_02_008).then(() => {
        this.$emit('ok')
      })
    },
    handleBack() {
      const bs_app_02_008 = {
        point_benepo: this.benepointAmount,
        checkedValue: this.checkedValue,
        dataItemOrder: this.dataItemOrder,
        itemContent: this.itemContent,
        totalAmount: this.totalCost
      }
      this.$store.dispatch(SAVE_DATA_BS_APP_02_008, bs_app_02_008).then(() => {
        // show pop up, navi screen ...
      })
      this.$router.go(-1)
    },
    formatNumber(value) {
      return value != null && !isNaN(value) ? new Intl.NumberFormat().format(value) : "";
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>